module.exports = __webpack_public_path__ + "static/media/03_before.fa368a6b.jpeg";